<template>
  <template v-if="inline">
    <slot />
  </template>
  <template v-else-if="mounted">
    <Teleport :to="appendTo">
      <slot />
    </Teleport>
  </template>
</template>

<script>
import { isClient } from '../../utils/dom';

export default {
  name: 'UiPortal',
  props: {
    appendTo: {
      type: [String, Object],
      default: 'body'
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      mounted: false
    };
  },
  computed: {
    inline (){
      return this.disabled || this.appendTo === 'self';
    }
  },
  mounted () {
    this.mounted = isClient();
  },
};
</script>
